import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, ShoppingCartIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { Cart } from './Cart';
const LoadingRoller = () => <div className="w-1 h-1 relative" data-id="element-115">
    <div className="w-1 h-1 bg-red-600/50 rounded-full animate-ping absolute" data-id="element-116"></div>
    <div className="w-1 h-1 bg-red-600 rounded-full" data-id="element-117"></div>
  </div>;
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const {
    state
  } = useCart();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleAboutClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setMobileMenuOpen(false);
  };
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/90 backdrop-blur-sm py-2' : 'bg-transparent py-4'}`} data-id="element-118">
        <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-119">
          <nav className="hidden md:flex items-center space-x-4" data-id="element-120">
            <Link to="/" className="font-display italic text-white hover:text-red-500 transition" data-id="element-121">
              Home
            </Link>
            <LoadingRoller data-id="element-122" />
            <Link to="/products" className="font-display italic text-white hover:text-red-500 transition" data-id="element-123">
              Products
            </Link>
            <LoadingRoller data-id="element-124" />
            <a href="#about" onClick={handleAboutClick} className="font-display italic text-white hover:text-red-500 transition" data-id="element-125">
              About
            </a>
            <LoadingRoller data-id="element-126" />
            <a href="https://chicagokush.myshopify.com" target="_blank" rel="noopener noreferrer" className="font-display italic text-white hover:text-red-500 transition" data-id="element-127">
              Shop
            </a>
            <LoadingRoller data-id="element-128" />
            <button onClick={() => setCartOpen(true)} className="font-display italic bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-full transition flex items-center" data-id="element-129">
              <ShoppingCartIcon size={18} className="mr-2" data-id="element-130" />
              Cart ({state.items.length})
            </button>
          </nav>
          <div className="md:hidden flex items-center gap-4" data-id="element-131">
            <button onClick={() => setCartOpen(true)} className="text-white hover:text-red-500 transition" data-id="element-132">
              <ShoppingCartIcon size={24} data-id="element-133" />
            </button>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white hover:text-red-500 transition" data-id="element-134">
              {mobileMenuOpen ? <XIcon size={24} data-id="element-135" /> : <MenuIcon size={24} data-id="element-136" />}
            </button>
          </div>
        </div>
        <div className={`md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-sm transition-all duration-300 ${mobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`} data-id="element-137">
          <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-138">
            <Link to="/" className="font-display italic text-white hover:text-red-500 transition py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-139">
              Home
            </Link>
            <Link to="/products" className="font-display italic text-white hover:text-red-500 transition py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-140">
              Products
            </Link>
            <a href="#about" onClick={handleAboutClick} className="font-display italic text-white hover:text-red-500 transition py-2" data-id="element-141">
              About
            </a>
            <a href="https://chicagokush.myshopify.com" target="_blank" rel="noopener noreferrer" className="font-display italic text-white hover:text-red-500 transition py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-142">
              Shop
            </a>
          </nav>
        </div>
      </header>
      <Cart isOpen={cartOpen} onClose={() => setCartOpen(false)} data-id="element-143" />
    </>;
};